import { render } from "./etDesignFormItemContent.vue?vue&type=template&id=64a63ac0"
import script from "./etDesignFormItemContent.vue?vue&type=script&lang=js"
export * from "./etDesignFormItemContent.vue?vue&type=script&lang=js"

import "./etDesignFormItemContent.vue?vue&type=style&index=0&id=64a63ac0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__